import { useState } from "react";

/**
 * Icono ? discreto al lado de un titulo o label. Click abre popover con explicacion.
 * Mobile-first: el popover ocupa ancho completo bajo el icono.
 */
export function InfoButton({ children }: { children: React.ReactNode }) {
  const [open, setOpen] = useState(false);
  return (
    <span className="relative inline-flex">
      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          setOpen((v) => !v);
        }}
        className="inline-flex h-4 w-4 items-center justify-center rounded-full bg-leaf-100 text-[10px] font-bold text-leaf-700 hover:bg-leaf-200"
        aria-label="Mas informacion"
      >
        ?
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-30" onClick={() => setOpen(false)} aria-hidden />
          <div
            className="absolute left-0 top-full z-40 mt-2 w-64 rounded-xl bg-white p-3 text-xs text-leaf-800 shadow-xl ring-1 ring-leaf-200"
            onClick={(e) => e.stopPropagation()}
          >
            {children}
          </div>
        </>
      )}
    </span>
  );
}
